exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.productRow[data-v-1a71cfb8] {\n  opacity: 0.5;\n}\n.productRow.selected[data-v-1a71cfb8] {\n    opacity: 1;\n}\n.square[data-v-1a71cfb8] {\n  width: 20px;\n  height: 20px;\n  border-radius: 3px;\n  background-color: #FFF;\n  border-color: #8ca0b3;\n  border-width: 1px;\n  border-style: solid;\n  min-width: 20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-1a71cfb8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/calendar/filters/productFilter.vue
// module id = 2733
// module chunks = 0